import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.167 5.834a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m1.25-2.917a2.917 2.917 0 1 0 0 5.833 2.917 2.917 0 0 0 0-5.833M10 6.667h6.667V5H10zm3.333 7.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m1.25-2.917a2.917 2.917 0 1 0 0 5.834 2.917 2.917 0 0 0 0-5.834m-11.25 2.084V15H10v-1.666z"
    }, null, -1)
  ]))]))
}
export default { render: render }